/**
 * Five bands rather than four. The rounding up to a readable step is what
 * decides how much of the plot the data actually occupies, and at four bands a
 * peak of 204 rounds to a ceiling of 300 — a third of the panel left empty.
 */
export function niceScale(high: number, count = 5): { max: number; ticks: number[] } {
  if (high <= 0) return { max: 1, ticks: [0, 1] }
  const rough = high / count
  const magnitude = 10 ** Math.floor(Math.log10(rough))
  const normalised = rough / magnitude
  const step =
    (normalised <= 1
      ? 1
      : normalised <= 2
        ? 2
        : normalised <= 2.5
          ? 2.5
          : normalised <= 5
            ? 5
            : 10) * magnitude
  const max = Math.ceil(high / step) * step
  const ticks: number[] = []
  for (let value = 0; value <= max + step / 2; value += step) {
    ticks.push(Number(value.toPrecision(12)))
  }
  return { max, ticks }
}

/**
 * A series colour by slot, in the fixed order declared in `styles.css`. Never
 * cycled: past the eighth the tail drops to the neutral, because a ninth
 * invented hue is one nobody can tell from the third. Those sites stay
 * separable by the legend, the tooltip and the row hover, not by colour.
 */
export function seriesColor(slot: number): string {
  return slot < 8 ? `var(--series-${slot + 1})` : 'var(--series-muted)'
}

/** Up to `wanted` labels, always including both ends, never overlapping. */
export function tickIndexes(length: number, wanted = 5): number[] {
  const count = Math.min(wanted, length)
  if (count < 2) return length > 0 ? [0] : []
  const indexes = new Set<number>()
  for (let i = 0; i < count; i++) indexes.add(Math.round((i / (count - 1)) * (length - 1)))
  return [...indexes]
}
